import {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import {onAuthStateChanged} from 'firebase/auth';
import {auth} from '../services/firebaseConfig';
import {
  deactivatePublicAnalytics,
  isPublicAnalyticsPath,
  shouldInitializePublicAnalytics,
  trackPublicPageView,
} from '../utils/publicAnalytics';

export default function PublicAnalyticsRouteTracker() {
  const location = useLocation();
  const [authState, setAuthState] = useState(() => ({
    resolved: Boolean(auth.currentUser),
    authenticated: Boolean(auth.currentUser),
  }));

  useEffect(() => onAuthStateChanged(auth, (user) => {
    setAuthState({resolved: true, authenticated: Boolean(user)});
  }), []);

  useEffect(() => {
    if (!isPublicAnalyticsPath(location.pathname)) {
      deactivatePublicAnalytics();
      return;
    }
    if (!shouldInitializePublicAnalytics({
      pathname: location.pathname,
      authResolved: authState.resolved,
      authenticated: authState.authenticated,
    })) {
      deactivatePublicAnalytics();
      return;
    }
    trackPublicPageView({pathname: location.pathname, search: location.search});
  }, [authState.authenticated, authState.resolved, location.pathname, location.search]);
  return null;
}
